import type { LineCreate, NodeRef, RepertoireLine, RepertoireNode } from '../api/types';

/** Naming a path must preserve the policies of moves already added to the repertoire. */
export async function prepareLineSave(
  line: RepertoireLine,
  name: string,
  getNode: (ref: NodeRef) => Promise<RepertoireNode>,
): Promise<LineCreate> {
  if (!line.movesUci.length || line.nodes.length !== line.movesUci.length + 1) {
    throw new Error('This variation has no complete move order to save.');
  }
  const annotations: NonNullable<LineCreate['annotations']> = [];
  // Bound read concurrency for long lines.
  for (let start = 0; start < line.movesUci.length; start += 8) {
    const batch = await Promise.all(line.movesUci.slice(start, start + 8).map(async (uci, offset) => {
      const ply = start + offset;
      const node = await getNode(line.nodes[ply]);
      const edge = node.outgoing.find((candidate) => candidate.transition.uci === uci);
      if (!edge || !edge.enabled) {
        throw new Error('A move in this draft is no longer available. Your draft is kept; restore the move before saving.');
      }
      return {
        ply, role: edge.role, priority: edge.priority,
        ...(edge.comment == null ? {} : { comment: edge.comment }),
        ...(edge.maxLossCp == null ? {} : { maxLossCp: edge.maxLossCp }),
      };
    }));
    annotations.push(...batch);
  }
  return { rootId: line.rootId, name: name.trim() || 'New variation', movesUci: line.movesUci, annotations };
}
